import { EventEmitter } from 'events';

export default class GeoXpVideoEvents {
  constructor(geoXpCore, config) {
    // sanitise config
    this.config = structuredClone(config);

    // event emitter
    this.event = new EventEmitter();

    this.validConfig = false;

    // inits the instance based on config
    this.init();

    // connects core
    this.geoXpCore = geoXpCore;

    // subscribes core events
    this.geoXpCore.on('incoming', (spot) => this.checkVideoIncoming(spot.id));
    this.geoXpCore.on('active', (spot) => this.checkVideoActive(spot.id));
    this.geoXpCore.on('inactive', (spot) => this.checkVideoInactive(spot.id));

    console.info('[GeoXpVideo] instance created', this);
  }

  init() {
    // check videos array
    if (this.config?.videos && Array.isArray(this.config?.videos)) {
      this.validConfig = true;
    } else {
      console.warn('[GeoXpVideo.init] Missing videos array in GeoXpVideo configuration');
      this.validConfig = false;
    }
  }

  reload(config) {
    // sanitise config object
    this.config = structuredClone(config);
    // init buffer
    this.init();
    console.info('[GeoXpVideo.reload] config reloaded', this);
  }

  checkVideoIncoming(spotId) {
    if (!this.validConfig) return;
    const videos = this.config.videos?.filter((e) => e.spotId === spotId);

    if (videos.length === 0) {
      console.error('[GeoXpVideo.checkVideoIncoming] video spot not found');
      return;
    }

    videos.forEach((video) => this.event.emit('video-incoming', video));
  }

  checkVideoActive(spotId) {
    if (!this.validConfig) return;
    const videos = this.config.videos?.filter((e) => e.spotId === spotId);

    if (videos.length === 0) {
      console.error('[GeoXpVideo.checkVideoActive] video spot not found');
      return;
    }

    videos.forEach((video) => this.event.emit('video-active', video));
  }

  checkVideoInactive(spotId) {
    if (!this.validConfig) return;
    const videos = this.config.videos?.filter((e) => e.spotId === spotId);

    if (videos.length === 0) {
      console.error('[GeoXpVideo.checkVideoInactive] video spot not found');
      return;
    }

    videos.forEach((video) => this.event.emit('video-inactive', video));
  }

  videoStarted(spotId) {
    if (!this.validConfig) return;
    const videos = this.config.videos?.filter((e) => e.spotId === spotId);
    if (videos.length === 0) {
      return;
    }
    this.geoXpCore.spotActivated(spotId);
    videos.forEach((video) => this.event.emit('video-playing', video));
  }

  videoEnded(spotId) {
    if (!this.validConfig) return;
    const videos = this.config.videos?.filter((e) => e.spotId === spotId);
    if (videos.length === 0) {
      return;
    }
    this.geoXpCore.spotDeactivated(spotId);
    videos.forEach((video) => this.event.emit('video-ended', video));
  }

  videoReady(spotId) {
    if (!this.validConfig) return;
    const videos = this.config.videos?.filter((e) => e.spotId === spotId);
    videos?.forEach((video) => this.event.emit('video-ready', video));
  }

  on(eventName, listener) {
    if (typeof listener !== 'function') {
      console.error('[GeoXpVideo.on] listener must be a function');
      return;
    }
    this.event.on(eventName, listener);
  }

  once(eventName, listener) {
    if (typeof listener !== 'function') {
      console.error('[GeoXpVideo.once] listener must be a function');
      return;
    }
    this.event.once(eventName, listener);
  }

  off(eventName, listener) {
    if (typeof listener !== 'function') {
      console.error('[GeoXpVideo.off] listener must be a function');
      return;
    }
    this.event.off(eventName, listener);
  }
}
